import React, { useState } from 'react';
import { faFacebook, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const TabSection = ({ data = null, slug }) => {
    const [activeTab, setActiveTab] = useState(0);

    const ShareSocial = (share_type) => {
        let url = process.env.APP_URL + `/whitepaper-newsletter/${slug}`;
        if (share_type === 'facebook') {
            url = encodeURI(url);
            let base_url_fb = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            const newWindow = window.open(base_url_fb, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
        if (share_type === 'linkedin') {
            let base_url_linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
            const newWindow = window.open(base_url_linkedin, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
        if (share_type === 'twitter') {
            let base_url_twitter = `https://twitter.com/share?url=${url}`;
            const newWindow = window.open(base_url_twitter, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
    };

    const shareButton = () => {
        return (
            <>
                <div className="flex items-center pt-5">
                    <h3 className="text-lg font-semibold">Share:</h3>
                    <ul className='flex w-full'>
                        <li className="flex justify-between py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('facebook')} >
                            <FontAwesomeIcon size="xl" className='text-[#1877F2] px-4' icon={faFacebook} />
                        </li>
                        <li className="flex justify-between py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('twitter')}>
                            <FontAwesomeIcon size="xl" className='text-[#00acee] px-4' icon={faTwitter} />
                        </li>
                        <li className="flex justify-between py-4 mx-2 bg-white rounded-full shadow-lg cursor-pointer hover:bg-gray-100" onClick={() => ShareSocial('linkedin')}>
                            <FontAwesomeIcon size="xl" className='text-[#0072b1] px-4' icon={faLinkedin} />
                        </li>
                    </ul>
                </div>
            </>
        );
    };

    return (
        <>
            <h3 className='text-[26px] font-semibold pb-6 uppercase'>{data?.title}</h3>
            <div className="container mx-auto eventDetails">


                {/* Tab Buttons */}
                <div className="grid grid-cols-12 gap-4">
                    <div className='col-span-6 xl:col-span-3 lg:col-span-6'>
                        <div
                            onClick={() => setActiveTab(0)}
                            className={`px-4 cursor-pointer py-2 ${activeTab === 0
                                ? 'border-b-4 border-[#1b5df3] text-[#1b5df3] shadow-lg'
                                : 'text-black'
                                } rounded-md border transition-colors duration-300 focus:outline-none font-semibold`}
                        >
                            What To Expect
                        </div>


                    </div>
                    <div className='col-span-6 xl:col-span-3 lg:col-span-6'>
                        <div
                            onClick={() => setActiveTab(1)}
                            className={`px-4 cursor-pointer py-2 ${activeTab === 1
                                ? 'border-b-4 border-[#1b5df3] text-[#1b5df3] shadow-lg'
                                : 'text-black'
                                } rounded-md border transition-colors duration-300 focus:outline-none font-semibold`}
                        >
                            How We Can Help
                        </div>
                    </div>
                    <div className='col-span-6 xl:col-span-3 lg:col-span-6'>
                        <div
                            onClick={() => setActiveTab(2)}
                            className={`px-4 py-2 cursor-pointer ${activeTab === 2
                                ? 'border-b-4 border-[#1b5df3] text-[#1b5df3] shadow-lg'
                                : 'text-black'
                                } rounded-md border transition-colors duration-300 focus:outline-none font-semibold`}
                        >
                            Team
                        </div>
                    </div>
                    <div className='col-span-6 xl:col-span-3 lg:col-span-6'>
                        <div
                            onClick={() => setActiveTab(3)}
                            className={`px-4 py-2 cursor-pointer ${activeTab === 3
                                ? 'border-b-4 border-[#1b5df3] text-[#1b5df3] shadow-lg'
                                : 'text-black'
                                } rounded-md border transition-colors duration-300 focus:outline-none font-semibold`}
                        >
                            Location
                        </div>
                    </div>
                </div>

                {/* Tab Content */}
                <div className="mt-4">
                    <div
                        className={`${activeTab === 0 ? 'block' : 'hidden'
                            } py-4 rounded-md`}
                    >
                        <p dangerouslySetInnerHTML={{ __html: data?.expect }}></p>
                        {shareButton()}
                    </div>
                    <div
                        className={`${activeTab === 1 ? 'block' : 'hidden'
                            } py-4 rounded-md`}
                    >
                        <p dangerouslySetInnerHTML={{ __html: data?.help }}></p>
                        {shareButton()}
                    </div>
                    <div
                        className={`${activeTab === 2 ? 'block' : 'hidden'
                            } py-4 rounded-md`}
                    >
                        <p dangerouslySetInnerHTML={{ __html: data?.team }}></p>
                        {shareButton()}
                    </div>
                    <div
                        className={`${activeTab === 3 ? 'block' : 'hidden'
                            } py-4 rounded-md`}
                    >
                        <p dangerouslySetInnerHTML={{ __html: data?.location }}></p>
                        {shareButton()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TabSection;
